export var getFeatureFlagsKey = function getFeatureFlagsKey() {
    return ['feature_flags'];
};
